 
// ================== OTHER ==================== //
import { Login } from './other/Login'; 
import { resendOTP } from './other/resendOTP'; 
import { validateOPT } from './other/validateOPT'; 
import { recoverPassword } from './other/recoverPassword'; 
import { alterPassword } from './other/alterPassword'; 
import { validatePassword } from './other/validatePassword'; 
import { extract } from './other/extract'; 
import { gerarFormacao } from './other/gerarFormacao'; 
import { validarQiz } from './other/validarQiz'; 






 
// ================== GET ==================== //
import { getUser } from './get/getUser'; 
import { getPerfil } from './get/getPerfil'; 
import { getDepartamento } from './get/getDepartamento'; 
import { getConteudo } from './get/getConteudo'; 
import { getFormacao } from './get/getFormacao'; 
import { getUserFormacao } from './get/getUserFormacao'; 
import { getUserFormacaoConteudo } from './get/getUserFormacaoConteudo'; 
import { getNota } from './get/getNota'; 
import { getPergunta } from './get/getPergunta'; 
import { getResposta } from './get/getResposta'; 
import { getPerguntaQuiz } from './get/getPerguntaQuiz'; 
import { getTotalFormacoes } from './get/getTotalFormacoes'; 
import { getDashboard } from './get/getDashboard'; 
import { rankingDepartamento } from './get/rankingDepartamento'; 
import { rankingFormacao } from './get/rankingFormacao'; 
import { rankingUsuario } from './get/rankingUsuario'; 
import { getPerguntasRespostas } from './get/getPerguntasRespostas'; 
import { getQuestionarioResultado } from './get/getQuestionarioResultado'; 
import { getQuestionariosUsers } from './get/getQuestionariosUsers'; 






// ================== ADD ==================== //
import { addUser } from './add/addUser'; 
import { addDepartamento } from './add/addDepartamento'; 
import { addConteudo } from './add/addConteudo'; 
import { addUserFormacao } from './add/addUserFormacao'; 
import { addDepartamentoFormacao } from './add/addDepartamentoFormacao'; 
import { addNota } from './add/addNota'; 
import { addRespostaQuiz } from './add/addRespostaQuiz'; 
import { criarQuestionario } from './add/criarQuestionario'; 



// ================== DELETE ==================== //
import { deleteUser } from './delete/deleteUser'; 
import { deleteDepartamento } from './delete/deleteDepartamento'; 
import { deleteConteudo } from './delete/deleteConteudo'; 
import { deleteUserFormacao } from './delete/deleteUserFormacao'; 


// ================== UPDATE ==================== //
import { updateUser } from './update/updateUser'; 
import { updateDepartamento } from './update/updateDepartamento'; 
import { updateConteudo } from './update/updateConteudo'; 
 






const Api = {
Login, 
resendOTP,
validateOPT,
recoverPassword,
alterPassword,
validatePassword,
getUser,
getDepartamento,
getPerfil,
addUser,
deleteUser,
updateUser,
addDepartamento,
deleteDepartamento,
updateDepartamento,
extract,
addConteudo,
getConteudo,
deleteConteudo,
updateConteudo,
gerarFormacao,
getFormacao,
getUserFormacao,
addUserFormacao,
addDepartamentoFormacao,
deleteUserFormacao,
getUserFormacaoConteudo,
addNota,
getNota,
getPergunta,
getResposta,
addRespostaQuiz,
getPerguntaQuiz,
validarQiz,
getTotalFormacoes,
rankingUsuario,
rankingDepartamento,
getDashboard,
rankingFormacao,
getPerguntasRespostas,
getQuestionarioResultado,
getQuestionariosUsers,
criarQuestionario,
 };


export default Api;